import config from "./globalConfig";

let themes = ["light", "dark"];

let chosenThemeIndex;

export function setTheme(chosenTheme) {
  localStorage.setItem("theme", chosenTheme);
  chosenThemeIndex = themes.indexOf(chosenTheme) + 1;
  theme = getTheme();
}
function getTheme() {
  let theme = {
    primaryRgb: "0, 100, 255",
    secondaryRgb: "229, 85, 65",
    tertiaryRgb: "0, 217, 131",

    primary: "#fff",
    secondary: "#E55541",
    tertiary: "#00D983",
    darkGrey: "#5e5e5e",
    grey: "#a7a7a7",
    lightGrey: "#d8d8d8",
    label: "#97A3B4",
    alpha3: "rgba(0,0,0,0.03)",
    alpha7: "rgba(0,0,0,0.07)",
    alpha9: "rgba(0,0,0,0.09)",
    alpha20: "rgba(0,0,0,0.20)",
    alpha30: "rgba(0,0,0,0.30)",
    white: "#fff",
    black: "#000",
    red: "#ff5555",
    yellow: "#FFCD02",
    green: "#1DBC60",
    overlay: "rgba(0, 0, 0, 0.4)",
    // logo: config.APP_LOGO,
    // logo_login: config.APP_LOGO_LOGIN,
    logoStyle: config.LOGO_STYLE,
    textHuge: 48,
    textBig: 24,
    textMedium: 18,
    textSmall: 14,
    textTiny: 10,
    blueText: "#26A557",
    redText: "#FC5959",
    gradient:
      "transparent linear-gradient(64deg, rgb(148, 30, 60) 0%, rgb(189, 19, 65) 30%, rgb(223, 10, 70) 59%, rgb(244, 4, 72) 84%, rgb(252, 3, 74) 100%) no-repeat scroll 0% 0%",
    draftColor: "#E2BA16",
    confirmedColor: "#32B114",
    cancelledColor: "#F85959",
    waitingColor: "#00B1FF",
    linkTextColor: "#232323",
    grayBackgroundColor: "#F2F2F2",
    settingTextColor: "#232323",
  };

  let which = localStorage.getItem("theme") || "light";

  //which='dark';
  switch (which) {
    case "light":
      theme = {
        ...theme,
        name: "light",
        header: "#F7F8F9",
        background: "#232323",
        backgroundPrimary: "#FFF",
        backgroundSecondary: "#f4f4f4",
        text: "#002257",
        logo: config.LIGHT_LOGO,
        // logoWithText: config.DARK_LOGO_TEXT,
        border: "rgba(255,255,255,0.5)",
        borderWidth: "1px",
        // favicon: favicon_light,
        label: "#5E6D82",
        //lightAccent: '#E4E6F1',
      };
      break;

    case "dark":
      theme = {
        ...theme,
        name: "dark",
        header: "#141E46",
        background: "#0D1539",
        // backgroundLight: '#131D47',
        text: "#fff",
        logo: config.DARK_LOGO,
        // logoWithText: config.LIGHT_LOGO_TEXT,
        border: "transparent",
        borderWidth: "0px",
        // favicon: favicon_dark,
        label: "#fff",
        //lightAccent: '#444c71',
      };
      break;

    default:
      theme = {
        ...theme,
        name: "light",
        header: "#F7F8F9",
        background: "#fff",
        text: "#002257",
        logo: config.LIGHT_LOGO,
        // logoWithText: config.DARK_LOGO_TEXT,
        border: "#E4E6F1",
        borderWidth: "1px",
        // favicon: favicon_light,
        label: "#5E6D82",
        //lightAccent: '#E4E6F1',
      };
      break;
  }

  return theme;
}

export let theme = getTheme();
